interface Labeled {
  label: string;
}

const labelComparator = (a: Labeled, b: Labeled) => (a.label ?? "").localeCompare(b.label ?? "");

export default labelComparator;
